import React, {
  ChangeEvent,
  DragEvent,
  useEffect,
  useRef,
  useState,
} from "react";
import { Modal } from "react-bootstrap";
import "./Popups.css";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import {
  useEditUserNameMutation,
  useprofilePicture,
} from "../../../../store/Apis/UserApi";
import ImageCropper  from "./ImageCropper";
import UploadIcon from "../../../../Custom-imeges/UploadIcon";
interface UpdateProfileProps {
  showModel: boolean;
  closeModal: () => void;
  avatarBackground: string | undefined;
}

const UpdateProfile = ({
  showModel,
  closeModal,
  avatarBackground,
}: UpdateProfileProps) => {
  const [image, setImage] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const userId = useAppSelector((s) => s.User.userData?.id) 
  const setProfilePage = useprofilePicture();
  const inputRef = useRef<HTMLInputElement>(null);
  const pictureUrl = useAppSelector((s) => s.User?.profilePictureURL)
  const [profilePictureUrl, setProfilePictureUrl] = useState<string | undefined>(undefined);
  const [updateProfilePicture, setUpdateProfilePicture] = useState(false);
  const userAvatar = useAppSelector((s) => s.User.userAvatar);
  const [fileName, setFileName]=useState<string>();
  const [isClickingNext, setIsClickingNext]=useState(false);
  useEffect(() => {
    if (pictureUrl) {
      setProfilePictureUrl(pictureUrl);
    } else if (image) {
      setProfilePictureUrl(image);
    }
  }, [pictureUrl, image]);

  useEffect(() => {
    if (showModel && inputRef.current) {
      inputRef.current.focus();
    } else if (!showModel) {
      setIsClickingNext(false);
      setTimeout(() => {
        setImage(null);
      }, 2000);
    }
  }, [showModel]);
  const handleDivClick = () => {
    fileInputRef.current?.click();
  };

  const handleDeleteUserImage = () => {
    setImage(null);
  };
const handleImageUpload = (e: ChangeEvent<HTMLInputElement>) => {
  setUpdateProfilePicture(true);
  const file = e.target.files?.[0];
  if (!file) return;
  setFileName(file?.name)
  const reader = new FileReader();
  reader.addEventListener("load", () => {
    const imageUrl = reader.result?.toString() || "";
      setImage(imageUrl);
  });
  reader.readAsDataURL(file);
};

  const updateImage = (imgSrc: string) => {
    setProfilePictureUrl(imgSrc);
  };

function base64ToFile(base64:String, filename: string) {
  // Decode the base64 string
  const byteString = atob(base64?.split(',')[1]);
  const base64SplitData = base64?.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
  if (base64SplitData === null || base64SplitData.length === 0)
    return;
  const mimeType = base64SplitData[1];
  // Create an array of byte values
  const byteNumbers = new Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
      byteNumbers[i] = byteString.charCodeAt(i);
  }

  // Convert byte array to a Blob, then a File
  const byteArray = new Uint8Array(byteNumbers);
  const file = new File([byteArray], filename, { type: mimeType });
  
  return file;
}

  const handleSavePicture = () => {
    if (profilePictureUrl && userId && fileName) {
    const imageFile = base64ToFile(profilePictureUrl, fileName);
    setProfilePage({ file: imageFile, userId: userId });
  }
  closeModal();
};

  const handleCancel = () => {
    closeModal();
    setUpdateProfilePicture(false);
    setProfilePictureUrl(undefined);
  };
const setIsNext=()=>{
  setIsClickingNext(true);
}
  return (
    <Modal
      className="model_container"
      show={showModel}
      backdrop="static"
      centered
    >
      <Modal.Header className="modal_header">
        <Modal.Title>
          <p className="mb-0 model-title-profile-picture">
            Update profile picture
          </p>
        </Modal.Title>
        <img
          className="arrowIconImg icon-profile-picture"
          src="/Images/SettingsSideResources/icn-arrow-left.svg"
          onClick={handleCancel}
          alt="Go back"
        />
      </Modal.Header>
      <Modal.Body className="modal_body user_popup">
        {updateProfilePicture ? (
          <ImageCropper
            imgSrc={image!}
            updateImage={updateImage}
            closeModal={() => setUpdateProfilePicture(false)}
            setIsNext={setIsNext}
          />
        ) : (
          <>
            <div onClick={handleDivClick} style={{ position: "relative" }}>
              {profilePictureUrl ? (
                <div>
                  <img
                    src={profilePictureUrl}
                    className="user_avatar_name"
                    alt="User avatar"
                  />
                  {!isClickingNext && (
                    <div
                      className="Upload-icon"
                    >
                      <UploadIcon />
                    </div>
                  )}
                </div>
              ) : (
                <span
                  className="user_avatar_name "
                  style={{ backgroundColor: avatarBackground }}
                >
                  {userAvatar}
                  {!isClickingNext && (
                    <div className="Upload-icon">
                      <UploadIcon />
                    </div>
                  )}
                </span>
              )}
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />
            </div>
            {isClickingNext && (
            <div className="containerButtons mt-4 w-100 d-flex justify-content-evenly">
              <button
                className="cancel-btn-profile-picture"
                 onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="save-btn-profile-picture"
                onClick={handleSavePicture}
              >
                Save
              </button>
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default UpdateProfile;
